/**
 * > When using the esBuild API, all `process.env.NODE_ENV` expressions
 * > are automatically defined to `"production"` if all minification
 * > options are enabled and `"development"` otherwise. This only happens
 * > if `process`, `process.env`, and `process.env.NODE_ENV` are not already
 * > defined. This substitution is necessary to avoid code crashing instantly
 * > (since `process` is a Node API, not a web API).
 * > — https://esbuild.github.io/api/#platform
 */

const NODE_ENV = process.env.NODE_ENV
const IS_MOBILE = window.matchMedia('(any-pointer:coarse)').matches

// Main environment variables
const ENV = Object.freeze({
    // Node environment
    NAME: NODE_ENV,
    IS_PROD: NODE_ENV === 'production',
    IS_DEV: NODE_ENV === 'development',

    // Device
    IS_MOBILE,
    IS_DESKTOP: !IS_MOBILE,
    IS_TOUCH: 'ontouchstart' in document.documentElement,

    // Reduced motion
    REDUCED_MOTION: window.matchMedia('(prefers-reduced-motion: reduce)').matches
})

// Main CSS classes used within the project
const CSS_CLASS = Object.freeze({
    LOADING: 'is-loading',
    LOADED: 'is-loaded',
    READY: 'is-ready',
    FONTS_LOADED: 'fonts-loaded',
    LAZY_CONTAINER: 'c-asset',
    LAZY_LOADED: '-lazy-loaded',
    LAZY_LOADING: '-lazy-loading',
    LAZY_ERROR: '-lazy-error',
    REDUCED_MOTION: 'reduced-motion',
})

// Custom js events
const CUSTOM_EVENT = Object.freeze({
    RESIZE_END: 'loco.resizeEnd',
    READY: 'loco.ready',
})

// Fonts parameters
const FONT = Object.freeze({
    EAGER: [
        { family: 'Fellix', style: 'normal', weight: '400' },
        { family: 'Fellix', style: 'normal', weight: '500' },
        { family: 'Fellix', style: 'normal', weight: '700' },
        { family: 'Helvetica Now Text', style: 'normal', weight: '400' },
    ],
})

// Global variables
const VARS = {
    window: {
        width: window.innerWidth,
        height: window.innerHeight,
    },
    headerHeight: 136,
}

// Vue variables
const VUE = Object.freeze({
    delimiters: ['${', '}'],
})

export {
    ENV,
    CSS_CLASS,
    CUSTOM_EVENT,
    FONT,
    VARS,
    VUE,
}
